export default __webpack_public_path__ + "static/media/mario3.3608e315.jpg";